module.exports = __webpack_public_path__ + "img/ИФ-1(А)-010-m.52ed42a8.png";